import { Sections } from "@/generated/classes/AppSchema";

export function getUrlHashParams(urlHash: string): Record<string, string> {

  const hash = urlHash.substr(1);
  return hash.split("&").reduce(function(res, item) {
    const parts = item.split("=");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    res[parts[0]] = parts[1];
    return res;
  }, {});
}

export function scrollToSection (section: string): void {
  if (section != Sections.NONE) {
    const ficheContainer = document.getElementsByClassName("fiche")[0];
    const sectionContainer = document.getElementById(section);
    if (ficheContainer && sectionContainer) {
      // 64px is the height of the header
      window.scrollTo({
        top: sectionContainer.offsetTop - 64,
      })
    }
  }
}
